import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, unref as _unref, createTextVNode as _createTextVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, createVNode as _createVNode, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-035bb0de"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "title" }
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", null, "发票申请", -1))
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "tips" }, "* 仅提供电子发票", -1))
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", null, null, -1))
const _hoisted_5 = {
  key: 0,
  class: "selected-invoice-content"
}
const _hoisted_6 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "message-tips" }, " * 根据《中华人民共和国发票管理办法》的规定，销售商品、提供服务以及从事其他经营活动的单位和个人，对外发生经营业务收取款项，收款方应当向付款方开具发票。 ", -1))

import { useRoute, useRouter } from 'vue-router'
import { formatInvoiceItem, OrderInvoiceApplyInfo } from '@/types/invoice'
import { InvoiceUserSelectStorage } from '@/storage/invoice'
import {
  onActivated,
  onMounted,
  ref,
  Ref,
  computed,
  withDefaults,
} from 'vue'
import CellWrap from '../CommonCellWrap.vue'
import InvoiceTypeSelect from './invoice-type-select.vue'
import UserInvoiceBaseInfo from '@/components/invoice/invoice-base-info.vue'
import appHost from '@/utils/app'

export default /*#__PURE__*/_defineComponent({
  __name: 'order-inovice-apply',
  props: {
    invoiceData: null,
    isDetail: { type: Boolean, default: false },
    url: { default: '' }
  },
  emits: ['change', 'init'],
  setup(__props: any, { emit: emits }) {

const props = __props as { invoiceData?: OrderInvoiceApplyInfo, isDetail: boolean, url:string };


const $router = useRouter()

const show = ref(false)
const invoiceDom = ref(null)
const selectedData = computed(() => props.invoiceData)
const hasInvoiceData = computed(() => !!selectedData.value && selectedData.value.header)
function toSelectInvoice() {
  // show.value = true
  $router.push({
    name: 'invoice-user-invoice-list',
    query: {
      guid: selectedData.value?.guid,
    },
  })
}

function initInvoiceInfo() {
  // const data = InvoiceUserSelectStorage.get<formatInvoiceItem>()
  // selectedData.value = data
  // emits('change', data)
  emits('init', invoiceDom.value)
}
onActivated(() => {
  initInvoiceInfo()
})
onMounted(() => {
  initInvoiceInfo()
})

function openUrl() {
  if(props.url){
    appHost.openBrowser(props.url)
  }

}

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", {
    class: "order-invoice-apply-wrap block-margin",
    ref_key: "invoiceDom",
    ref: invoiceDom
  }, [
    _createElementVNode("div", _hoisted_1, [
      _hoisted_2,
      _hoisted_3,
      (_unref(hasInvoiceData)&& !__props.isDetail)
        ? (_openBlock(), _createElementBlock("div", {
            key: 0,
            class: "re-select",
            onClick: toSelectInvoice
          }, [
            _createTextVNode("重新选择"),
            _hoisted_4
          ]))
        : _createCommentVNode("", true),
      (__props.isDetail)
        ? (_openBlock(), _createElementBlock("div", {
            key: 1,
            class: _normalizeClass({
        're-select': true,
        'wait':!__props.url
      }),
            onClick: openUrl
          }, _toDisplayString(__props.url?'下载发票':'待开票'), 3))
        : _createCommentVNode("", true)
    ]),
    (_unref(hasInvoiceData))
      ? (_openBlock(), _createElementBlock("div", _hoisted_5, [
          _createVNode(UserInvoiceBaseInfo, { item: _unref(selectedData) }, null, 8, ["item"])
        ]))
      : (_openBlock(), _createBlock(CellWrap, {
          key: 1,
          class: "invoice-selected-wrap van-hairline--bottom",
          label: "请选择发票抬头",
          fillColor: "rgba(0,0,0,0.44)",
          onClick: toSelectInvoice
        })),
    _hoisted_6,
    _createVNode(InvoiceTypeSelect, {
      show: show.value,
      "onUpdate:show": _cache[0] || (_cache[0] = ($event: any) => ((show).value = $event))
    }, null, 8, ["show"])
  ], 512))
}
}

})